import Vue from 'vue'
import axios from 'axios'
import { Toast, Dialog } from 'mand-mobile'
import router from '../router'
var isshowcona=true
const AJAx = (url, type, data) => {
  const hostUrl = ''
  const ax = {
    method: type,
    url: hostUrl + '/shop' + url,
    headers: {
      platform: 'h5',
      platformObj: JSON.stringify({
        platform: 'h5'
      }),
      'content-type': 'application/json',
      Authorization: localStorage.getItem('mupressMobiltoken') ? localStorage.getItem('mupressMobiltoken') : null,
      refreshToken: localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null,
      shopCode:(localStorage.getItem('userinfoMobie')&&localStorage.getItem('userinfoMobie')!=undefined&&localStorage.getItem('userinfoMobie')!='undefined') ?JSON.parse(localStorage.getItem('userinfoMobie')).shopCode  :(localStorage.getItem('shopkey') ?JSON.parse(localStorage.getItem('shopkey')).appCode:null),
    },
    data: {},
    timeout: 1500000
  }
  if (type == 'post') {
    ax.data = data
  } else if (type == 'get' || type == 'delete') {
    ax.params = data
  }
  const res = axios(ax).then((data) => {
    // console.log(isshowcona)
    // console.log(data)
    // 自定义模块
    if (data.status == 200) {
      if (data.data.code == 'S000') {
        return Promise.resolve(data.data.data)
      } else if (data.data.code == 'E003' ||data.data.code == 'E004') {
        if(isshowcona){
          isshowcona=false
          Dialog.confirm({
            content: data.data.message,
            confirmText: '确定',
            onConfirm: () => {
              isshowcona=true
              router.push({ name: 'Login' })
              localStorage.removeItem('mupressMobiltoken')
              localStorage.removeItem('userinfoMobie')
            },
            onCancel: () => {
              isshowcona=true
              router.replace({ name: 'Home' })
              localStorage.removeItem('mupressMobiltoken')
              localStorage.removeItem('userinfoMobie')
            }
          })
        }
      } else if(data.data.code == 'ENTRUST_TRUE') {
        return Promise.reject(data)
      }else{
        Toast.failed(data.data.message)
        return Promise.reject(data)
      }
    } else {
      Toast.failed('系统异常')
    }
    // 自定义模块 END
  }).catch((error) => {
    return Promise.reject(error.data)
  })
  return res
}

export default {
  AJAx
}
